//  validates that both passwords match
export const validateCheckbox = (checked, context) => {
    const { createError, type } = context;
    const error = createError({ message: type });

    if (!checked || checked.length === 0) return error;

    return true;
};
